import { LoginState } from "@/models/LoginState";
import { getCommunicationType } from "@/utils/validators";
export const LoginGetters = {
	IS_LOGGED_IN: 'IS_LOGGED_IN',
	HAS_VALID_COMMUNICATION_METHOD: 'HAS_VALID_COMMUNICATION_METHOD',
	COMMUNICATION_TYPE: 'COMMUNICATION_TYPE',
	COMMUNICATION: 'COMMUNICATION'
}

export default {
	[LoginGetters.IS_LOGGED_IN]: (state: LoginState): boolean => {
		return !!state.userJWT;
	},
	[LoginGetters.HAS_VALID_COMMUNICATION_METHOD]: (state: LoginState): boolean => {
		const type = getCommunicationType(state.communication);
		return !!type;
	},
	[LoginGetters.COMMUNICATION_TYPE]: (state: LoginState): string => { 
		return getCommunicationType(state.communication)
	},
	[LoginGetters.COMMUNICATION]: (state: LoginState): string => {
		return state.communication;
	}
}
